<template>
  <div>


    <b-card no-body >
      <b-card-body class="px-1 pt-1 pb-0">
        <b-row>
          <!-- Per Page -->
          <b-col
              xl="2"
              md="9"
              sm="6"
          >
            <b-form-group v-if="showRangeFecha">
              <label>Rango de fecha</label>
              <flat-pickr
                  id="rangeFechaFil"
                  v-model="rangeDateFil"
                  class="form-control"
                  :config="{
                    mode: 'range',
                    dateFormat: 'd/m/Y',
                    locale: 'es',

                  }"
                  style="height: 31px"

              />
            </b-form-group>
          </b-col>

          <b-col
              xl="2"
              md="9"
              sm="6"
              class="mb-md-0 mb-2"
          >
            <b-form-group
                label=""
                label-for="id_cultivo"
            >
              <label>&nbsp;</label>
              <br>
              <b-button
                  variant="gradient-primary"
                  size="sm"
                  @click="filtrarLista"
              >
                <feather-icon
                    icon="PlusIcon"
                    class="mr-50"
                />
                <span class="align-middle">Filtrar</span>
              </b-button>
            </b-form-group>

          </b-col>


          <!-- Search -->
        </b-row>
      </b-card-body>
    </b-card>
    <b-card no-body >
      <b-card-body >

        <div class="d-flex justify-content-between  flex-wrap">
          <!-- Registar categoría  -->
          <b-form-group
              label-for="filterInput"
              class="mb-0"
          >
            <b-button
                variant="gradient-primary"
                size="sm"
                class="mr-1"
                @click="filtrarLista"
            >

              <feather-icon
                  icon="RefreshCwIcon"
              />
            </b-button>
            <b-button
                variant="gradient-success"
                size="sm"
                @click=""
                v-if="false"
            >
              <feather-icon
                  icon="PlusIcon"
                  class="mr-50"
              />
              <span class="align-middle">Exportar</span>
            </b-button>

          </b-form-group>

          <!-- filter -->
          <b-form-group
              label-for="filterInput"
              class="mb-0"
          >
            <b-input-group size="sm">
              <b-form-input
                  id="filterInput"
                  v-model="filter"
                  type="search"
                  placeholder="Buscar"
              />
              <b-input-group-append>
                <b-button
                    :disabled="!filter"
                    @click="filter = ''"
                >
                  Borrar
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>

        </div>

      </b-card-body>

      <b-table
          v-if="$can('read', 'Resumen Ratio Re')"
          hover
          responsive
          class="position-relative"
          :per-page="perPage"
          :current-page="currentPage"
          :items="items"
          :fields="fields"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          :filter="filter"
          :filter-included-fields="filterOn"
          @filtered="cPaginacion"
          :busy="loading"
          show-empty
          empty-text="No se encontraron datos en esta tablas."
          emptyFilteredText="No se encontraron datos con los parámetros ingresados."
      >
        <!--
        <template #cell(fecha_n)="data">
          {{ data.value }} @ {{ data.value.split('-')[2] }}/{{ data.value.split('-')[1] }}/{{ data.value.split('-')[0] }}
        </template>
        -->

        <template #table-busy>
          <div class="text-center text-dark my-1">
            <b-spinner class="align-middle"></b-spinner> &emsp;
            <strong>Obteniendo datos...</strong>
          </div>
        </template>

        <template #cell(nuevo_empresa)="data">
          <b-badge :variant="status[1][data.value]">
            {{ status[0][data.value] }}
          </b-badge>
        </template>
        <template #cell(nuevo_empresa)="data">
          <b-badge :variant="status[1][data.value]">
            {{ status[0][data.value] }}
          </b-badge>
        </template>
        <template #cell(nuevo_cosecha)="data">
          <b-badge :variant="status[1][data.value]">
            {{ status[0][data.value] }}
          </b-badge>
        </template>

      </b-table>

      <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
        <!-- page length -->
        <b-form-group
            label="Mostrar"
            label-cols="5"
            label-align="left"
            label-size="sm"
            label-for="sortBySelect"
            class="text-nowrap mb-md-0 mr-1"
        >
          <b-form-select
              id="perPageSelect2"
              v-model="perPage"
              size="sm"
              inline
              :options="pageOptions"
          />

        </b-form-group>

        <!-- pagination -->
        <div>
          <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              first-number
              last-number
              prev-class="prev-item"
              next-class="next-item"
              class="mb-0"
          >
            <template #prev-text>
              <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
              />
            </template>
          </b-pagination>
        </div>
      </b-card-body>

    </b-card>
  </div>

</template>

<script>
import axiosIns from '../../../libs/axios'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import flatPickr from 'vue-flatpickr-component'
import { Spanish } from "flatpickr/dist/l10n/es.js"

import {
  BCard,
  BTable,
  BAvatar,
  BBadge,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BCardBody,
  BTooltip,
  BModal,
  VBModal,
  BListGroup,
  BListGroupItem,
  BRow,
  BCol, BSpinner
} from 'bootstrap-vue'
import axios from "axios";

export default {
  components: {
    BCard,
    BTable,
    BAvatar,
    BBadge,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BCardBody,
    BTooltip,
    BModal,
    VBModal,
    BListGroup,
    BListGroupItem,
    BRow,
    BCol,
    vSelect,
    ToastificationContent,
    BSpinner,
    flatPickr,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {

      perPage: 5,
      pageOptions: [5, 10, 15],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      estadoModal: false,
      showRangeFecha:true,
      showFecha:true,
      src: '',
      infoModal: {
        title: '',
        boton: '',
      },
      fields: [
        {
          key: 'empresa',
          label: 'Empresa',
          sortable: true
        },
        {
          key: 'dni_trabajador',
          label: 'DNI',
          sortable: true
        },
        {
          key: 'nombres_trabajador',
          label: 'TRABAJADOR',
          sortable: true
        },
        {
          key: 'fecha_tareo',
          label: 'FECHA TAREO',
          sortable: true
        },
        {
          key: 'cumplimiento_cuadrilla',
          label: 'cumplimiento cuadrilla %',
          sortable: true
        },
      ],
      items: [],
      loading: false,
      show: false,
      tipoOptionsSelected: null,
      tipoOptions: [
        {value: '0', text: "FECHA ESPECIFICA"},
        {value: '1', text: "RANGO FECHA"}
      ],
      fechaSelect:'',
      rangeDate: null,
      rangeDateFil:null,





    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
          .filter(f => f.sortable)
          .map(f => ({
            text: f.label,
            value: f.key
          }))
    },
  },
  mounted() {
    this.validadEntradaRangeFiltro('1');

  },
  methods: {
    listarBajaProductividad(fecha_inicial,fecha_final){
      var yo = this

      yo.loading = true

      var body =  "" +
          "fecha_inicial=" +fecha_inicial+'&'+
          "fecha_final=" +fecha_final+
          "";

      var config = {
        method: 'get',
        url: '/cosecha/cosecha/bajaProductividadResumenRatio/list/?'+body,
        headers: { },
      };


      axiosIns(config)
          .then((response) => {
            yo.items = response.data.response;
            yo.totalRows = yo.items.length
            //console.log(yo.items);
          })
          .catch(function (error) {
            console.log(error);
          }).finally(function (){
        yo.loading = false
      });

    },
    filtrarLista(){
      var yo = this
      if(yo.tipoOptionsSelected == '0'){
        this.listarBajaProductividad('','');
      }else{
        yo.validadEntradaRangeFiltro();
      }

    },
    addHoursToDate(objDate, intHours) {
      var numberOfMlSeconds = objDate.getTime();
      var addMlSeconds = (intHours * 60) * 60000;
      var newDateObj = new Date(numberOfMlSeconds + addMlSeconds);

      return newDateObj;
    },
    validadEntrada(){
      const yo = this
      let fecha = yo.rangeDate;

      if(fecha !== null && fecha !== '') {
        let fecha_array = fecha.split(' a ')
        let fechaInicio = ''
        let fechaFin = ''
        if(fecha_array.length == 2){
          let sep_feha_in = fecha_array[0].split('/');
          let sep_feha_fin = fecha_array[1].split('/');
          fechaInicio = sep_feha_in[2]+"-"+sep_feha_in[1]+"-"+sep_feha_in[0]
          fechaFin = sep_feha_fin[2]+"-"+sep_feha_fin[1]+"-"+sep_feha_fin[0]
          var day1Inicial = new Date(fechaInicio);
          var day2Final = new Date(fechaFin);
          var difference= Math.abs(day2Final-day1Inicial);
          var days = (difference/(1000 * 3600 * 24))+1;
          if(days<=16){
            yo.abrir(fechaInicio,fechaFin);
          }else{
            yo.$swal.fire(
                'Mensaje',
                'El rango de fecha seleccionado supera los 15 días!',
                'warning'
            ).then((result) => {
            });
          }
        }else{
          yo.$swal.fire(
              'Mensaje',
              'Falta ingresar una fecha!',
              'warning'
          ).then((result) => {
          });
        }

      }else{
        yo.$swal.fire(
            'Mensaje',
            'Debe selecionar una fecha inicial y final',
            'warning'
        ).then((result) => {
        });
      }


    },
    validadEntradaRangeFiltro(tipo){
      const yo = this
      let fechaRangeTareo = yo.rangeDateFil;
      let fechaInicioRange = ''
      let fechaFinRange = ''

      if(fechaRangeTareo == null || fechaRangeTareo == '') {

        if(tipo == '1'){

          let date_Actual = new Date();
          let date_inicial = yo.addHoursToDate(date_Actual,-168);
          let date_final = yo.addHoursToDate(date_Actual,-24);
          var fecha_inicial = date_inicial.getFullYear() +'-' + String(date_inicial.getMonth() + 1).padStart(2, '0')+'-'+ String(date_inicial.getDate()).padStart(2, '0');
          var fecha_final = date_final.getFullYear() +'-' + String(date_final.getMonth() + 1).padStart(2, '0')+'-'+ String(date_final.getDate()).padStart(2, '0');
          var fecha_inicial_f = String(date_inicial.getDate()).padStart(2, '0')+'/'+String(date_inicial.getMonth() + 1).padStart(2, '0')+'/'+date_inicial.getFullYear();
          var fecha_final_f = String(date_final.getDate()).padStart(2, '0')+'/'+String(date_final.getMonth() + 1).padStart(2, '0')+'/'+date_final.getFullYear();
          this.rangeDateFil = [fecha_inicial_f,fecha_final_f];
          fechaInicioRange = fecha_inicial;
          fechaFinRange = fecha_final;
          yo.listarBajaProductividad(fechaInicioRange,fechaFinRange);

        }else{

          yo.$swal.fire(
              'Mensaje',
              'Debe selecionar una fecha',
              'warning'
          ).then((result) => {
          });
        }

      }else{

        let fecha_array = fechaRangeTareo.split(' a ')

        if(fecha_array.length == 2){
          let sep_feha_in = fecha_array[0].split('/');
          let sep_feha_fin = fecha_array[1].split('/');
          fechaInicioRange = sep_feha_in[2]+"-"+sep_feha_in[1]+"-"+sep_feha_in[0];
          fechaFinRange = sep_feha_fin[2]+"-"+sep_feha_fin[1]+"-"+sep_feha_fin[0];

          var day1Inicial = new Date(fechaInicioRange);
          var day2Final = new Date(fechaFinRange);
          var difference= Math.abs(day2Final-day1Inicial);
          var days = (difference/(1000 * 3600 * 24))+1;
          if(days<=16){
            yo.listarBajaProductividad(fechaInicioRange,fechaFinRange);
          }else{
            yo.$swal.fire(
                'Mensaje',
                'El rango de fecha seleccionado supera los 16 días!',
                'warning'
            ).then((result) => {
            });
          }
        }else{
          let sep_feha_in = fecha_array[0].split('/');
          fechaInicioRange = sep_feha_in[2]+"-"+sep_feha_in[1]+"-"+sep_feha_in[0];
          fechaFinRange = sep_feha_in[2]+"-"+sep_feha_in[1]+"-"+sep_feha_in[0];
          yo.listarBajaProductividad(fechaInicioRange,fechaFinRange);
        }

      }



    },
    cPaginacion(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
